export const newCarListingLeaderboard = {
  smartObjectId: 'Banner - Desktop 970x90',
  target: 'dy_Banner_-_Desktop_970x90',
};
